var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWithdraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 206,
    viewBox: "0 0 140 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3453_2790)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 206,
    rx: 20,
    fill: "#7BBCA3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.785 -54.4541C153.076 -56.8867 166.59 -42.7446 160.866 -29.2538L105.778 100.58C100.16 113.819 80.1519 116.512 69.5819 105.451L-32.1162 -0.971709C-42.6862 -12.0328 -35.9897 -28.6554 -20.0019 -31.0427L136.785 -54.4541Z",
    fill: "url(#paint0_linear_3453_2790)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3453_2790",
    x1: 94.1344,
    y1: -161.789,
    x2: 185.654,
    y2: 33.4955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA10F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059157"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3453_2790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 206,
    rx: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.d75df44a943e738ea51184919d8eb42a.svg";
export { ForwardRef as ReactComponent };